module.exports = __webpack_public_path__ + "img/facebook.7e3d6796.svg";